module.exports = __webpack_public_path__ + "img/zh.01b1e165.svg";